/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelEdiStatusEvent.ts                *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/datafusion/edi-status-event";

export class AutogenModelEdiStatusEvent<RowType extends ModelRow> extends Endpoint<RowType, RowEdiStatusEventFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowEdiStatusEvent extends ModelRow<RowEdiStatusEventFields> {
	constructor(values?: Partial<RowEdiStatusEventFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowEdiStatusEventFields {
	alt_partner_id: string;
	appt_confirmed: string;
	appt_date_field: string;
	appt_date_table: string;
	batch_method: string;
	company_id: string;
	create_method: string;
	create_service_inc: string;
	default_delay_code: string;
	depart_can_arrive: string;
	descr: string;
	direction: string;
	display_sequence: number;
	event_type: string;
	grace_period: number;
	id: string;
	late_by_date_only: string;
	map_callin: string;
	map_comment: string;
	minimum_interval: number;
	partner_id: string;
	pickup_pos_lead_time: number;
	pickup_pos_prev_delivered: string;
	pickup_pos_stop_option: string;
	posted_type: string;
	req_src: string;
	resend_ear_req_src: string;
	resend_early_grace: number;
	resend_if_early: string;
	resend_if_late: string;
	resend_lat_req_src: string;
	resend_late_grace: number;
	send_all_instances: string;
	send_update: string;
	show_on_rpt: string;
	status_code: string;
	status_date_field: string;
	status_date_table: string;
	status_required: string;
	stop_type: string;
	time_required: string;
	un_delay_cross_ref: string;
	update_conf_appt: string;
	update_stop_pieces: string;
	update_stop_weight: string;
	version: string;
	xmit_sequence: number;
}

